import { ProductListDTO } from '../product/product-list.dto';
import { TeamAccessDTO } from '../team/team-access.dto';

export class PricelistItemListDTO extends TeamAccessDTO {

    id: string;

    price: number;

    product: ProductListDTO;

}
